import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MapConfigService, injectMapFeatureConfig } from '@navfleet/client/map/domain/data-access';
import { MAP_FEATURE_CONFIG, MapFeatureConfig, MapFeatureContribution } from '@navfleet/client/map/domain/models';
import {
    MAP_VESSEL_FOCUS_FEATURE_KEY,
    overrideMapVesselFocusConfig,
} from '@navfleet/client/map/vessel-position-focus/domain/models';
import { Observable } from 'rxjs';

// Re-exported from the models lib, so map configs in models and ui libs can use them
export { MAP_VESSEL_FOCUS_FEATURE_KEY, overrideMapVesselFocusConfig };

/** Typed accessor for the merged feature config (defaults + container override). */
export const injectMapVesselFocusConfig = (): Observable<MapFeatureConfig> =>
    injectMapFeatureConfig<MapFeatureConfig>(MAP_VESSEL_FOCUS_FEATURE_KEY);

/**
 * Pure variant — use only when you already hold a MapConfigService reference
 * (e.g. inside another service that received it via constructor).
 */
export const getMapVesselFocusConfig = (service: MapConfigService): Observable<MapFeatureConfig> =>
    service.getFeatureConfig(MAP_VESSEL_FOCUS_FEATURE_KEY) as Observable<MapFeatureConfig>;

/** Default config contributed at app bootstrap. */
const DEFAULT_VESSEL_FOCUS: MapFeatureConfig = {
    enabled: false,
    // …feature-specific defaults…
};

/** Multi-provider registration. Call this once in ClientShellModule (or equivalent). */
export function provideMapVesselFocusFeature(overrides: Partial<MapFeatureConfig> = {}): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: MAP_FEATURE_CONFIG,
            multi: true,
            useValue: {
                [MAP_VESSEL_FOCUS_FEATURE_KEY]: { ...DEFAULT_VESSEL_FOCUS, ...overrides },
            } satisfies MapFeatureContribution,
        },
    ]);
}
